import React from 'react';
import { Backdrop, CircularProgress, Box } from '@mui/material';
import { useLoading } from '../contexts/loadingContext';

export default function GlobalSpinner() {
  const { isLoading } = useLoading();

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}